import axios from 'axios';

const apiAuth = axios.create({
  baseURL: `${process.env.REACT_APP_INSV_API_AUTH}`
});
apiAuth.interceptors.request.use(async (config) => {
  const token = localStorage.tolkenINSV;

  if (token)
    config.headers.authorization = `${token}`;

  return config;
});

apiAuth.interceptors.response.use(
  (response) => {
    return response;
  },
  
  (err) => Promise.reject(err)
);

export default apiAuth